/**
 * Singleton to prevent duplicate Pusher subscriptions across component remounts.
 * Automatically cleans up old subscriptions when resubscribing to the same clipId.
 */
export class SubscriptionManager {
  private static instance: SubscriptionManager;
  private subscriptions: Map<string, () => void> = new Map();

  private constructor() {}

  static getInstance(): SubscriptionManager {
    if (!SubscriptionManager.instance) {
      SubscriptionManager.instance = new SubscriptionManager();
    }
    return SubscriptionManager.instance;
  }

  subscribe(clipId: string, unsubscribe: () => void): void {
    if (this.subscriptions.has(clipId)) {
      this.subscriptions.get(clipId)?.();
    }
    this.subscriptions.set(clipId, unsubscribe);
  }

  unsubscribe(clipId: string): void {
    if (this.subscriptions.has(clipId)) {
      this.subscriptions.get(clipId)?.();
      this.subscriptions.delete(clipId);
    }
  }

  isSubscribed(clipId: string): boolean {
    return this.subscriptions.has(clipId);
  }
}
